export const isPersian = (str) => {
	const p = /^[\u0600-\u06FF\s]+$/;
	return p.test(str) && str !== ' ';
};

export const isPersianNumber = (str) => {
	const n = /^[\u06F0-\u06F9]+$/;
	return n.test(str);
};
